import BotCheckerForm from "./bot-checker-form";
import Micromodal from "../lib/micromodal";
export default class ButtonHandler {
    constructor() {
        this.botCheckerForm = new BotCheckerForm();

        setTimeout(() => {
            Micromodal.init({
                disableScroll: true,
                awaitOpenAnimation: true,
                awaitCloseAnimation: true,
                debugMode: false
            });
        }, 0)

        this.success = document.querySelectorAll('.modal .alert-success');
        this.danger = document.querySelectorAll('.modal .alert-danger');
        this.initListeners();
    }

    initListeners() {
        // Возврат уведомлений в дефолтное положение
        cl.addEvent(document, 'click', '.connect_button, .connect_btn, .citylink-button, [js-connect-tariff], [js-about-connect]', () => {
            cl.hide(this.success);
            cl.hide(this.danger);
        })

        // header button
        cl.addEvent(document,'click', '.connect_button', (e) => {
            this.setForm(
                this.getCity(),
                'Услуга: не выбрано.'
            );
        })

        // footer button
        cl.addEvent(document,'click', '.js-recall', (e) => {
            this.setForm(
                this.getCity(),
                'Услуга: заказ обратного звонка.'
            );
        })

        // Обработка кнопки в тарифах
        cl.addEvent(document, 'click', '.tariff-card .citylink-button, [js-connect-tariff]', (e) => {
            const _this = e.target;
            let city = this.getCity();
            let card = _this.closest('.tariff-card');
            let primaryTab = document.querySelector('.tariff__tab.tariff__tab_active');
            let tab = document.querySelector('.nav-link.active');
            let service = 'Заявка на подключение ';
            service += primaryTab !== null ? `"${primaryTab.innerText.trim()}": ` : '';

            if (tab) {
                service += `${tab.innerText.trim()}`;

                let checked = card.querySelector('input:checked');
                if (checked) {
                    let months = checked.dataset.info;
                    service += ` (${months})`;
                }

                service += '; ';
            }

            let tariffName = card.querySelector('.js-get-t-name');

            if (tariffName) {
                service += `Название: "${tariffName.innerText.trim()}"; `;
            }
            let speed = card.querySelector('.js-get-speed');
            if (speed) {
                service += `Скорость/Каналы: ${speed.innerText.trim()}; `;
            }
            let price = card.querySelector('.js-get-month-price');
            let contractPrice = card.querySelector('.contract-price__actual.active')
            if (price) {
                service += `Цена: ${price.innerText.trim()} р/мес`;
            } else if (contractPrice) {
                service += `Цена: ${contractPrice.innerText.trim()} р/мес`
            }

            this.setForm(city, service);
        })

        // заполнение заявки на странице акций
        cl.addEvent(document,'click', '.promo .citylink-button', (e) => {
            this.setForm(
                this.getCity(),
                'Промо-акция: ' + document.querySelector('head title').innerText.trim()
            );
        })

        // заполнение заявки на странице о компании
        cl.addEvent(document,'click', '.about .citylink-button', (e) => {
            this.setForm(
                this.getCity(),
                'Заявка на подключение со страницы "О компании"'
            );
        })

        // здесь обработка формы подачи заявки
        cl.addEvent(document,'click', '.citylink-button.connect', (e) => {
            let form = this.validateModal(e.target)

            if (!form.valid) {
                return false;
            }

            //Отрубаем кнопку во избежание спама заявок на заказ обратного звонка
            //https://redmine.karelia.pro/issues/30521
            e.target.setAttribute('disabled', 'true');
            e.target.classList.add('citylink-button_disabled');

            this.botCheckerForm.setCookie(
                "cl-time-on-page",
                this.botCheckerForm.getTimeFromStart(),
                1
            );

            const nameInput = cl.first(form.inputs, v => v.classList.contains('user-name'));
            const phoneInput = cl.first(form.inputs, v => v.classList.contains('user-phone'));
            const cityInput = cl.first(form.inputs, v => v.name === 'city');
            const serviceInput = cl.first(form.inputs, v => v.name === 'service');
            const whereInput = cl.first(form.inputs, v => v.name === 'where');
            const faxInput = cl.first(form.inputs, v => v.name === 'fax');

            const data = {
                name: nameInput ? nameInput.value : 'Быстрая заявка',
                phone: phoneInput ? phoneInput.value : null,
                city: cityInput ? cityInput.value : null,
                service: serviceInput ? serviceInput.value : null,
                where: whereInput ? whereInput.value : null,
                fax: faxInput ? faxInput.value : null,
                reCaptchaToken: this.botCheckerForm.getGRecaptchaToken()
            }

            fetch('/forms/connect/' + this.getQueryString(), {
                method: 'POST',
                headers: cl.headers(),
                body: JSON.stringify(data)
            })
                .then(async (response) => {
                    return {
                        success: response.ok,
                        content: await response.text()
                    }
                })
                .then((data) => {
                    if (data.success) {
                        this.showSuccess(data.content)
                    } else {
                        this.showDanger(data.contents)
                    }
                })
                .catch((err) => {
                    this.showDanger('Что-то пошло не так. Попробуйте позже или позвоните нам по номеру 555-777')
                })
        })

        // здесь будет обработка формы заказа звонка
        cl.addEvent(document,'click', '.citylink-button.recall', (e) => {
            let form = this.validateModal(e.target)

            if (!form.valid) {
                return false;
            }

            //Отрубаем кнопку во избежание спама заявок на заказ обратного звонка
            //https://redmine.karelia.pro/issues/30521
            e.target.setAttribute('disabled', 'true');
            e.target.classList.add('citylink-button_disabled');

            this.botCheckerForm.setCookie(
                "cl-time-on-page",
                this.botCheckerForm.getTimeFromStart(),
                1
            );

            const nameInput = cl.first(form.inputs, v => v.id === 'recall-name');
            const phoneInput = cl.first(form.inputs, v => v.id === 'recall-phone');
            const cityInput = cl.first(form.inputs, v => v.name === 'city');
            const serviceInput = cl.first(form.inputs, v => v.name === 'service');
            const faxInput = cl.first(form.inputs, v => v.name === 'fax');

            const data = {
                name: nameInput ? nameInput.value : 'Быстрая заявка',
                phone: phoneInput ? phoneInput.value : null,
                city: cityInput ? cityInput.value : null,
                service: serviceInput ? serviceInput.value : null,
                fax: faxInput ? faxInput.value : null,
                reCaptchaToken: this.botCheckerForm.getGRecaptchaToken()
            }

            fetch('/forms/recall/' + this.getQueryString(), {
                method: 'POST',
                headers: cl.headers(),
                body: JSON.stringify(data)
            })
                .then(async (response) => {
                    return {
                        success: response.ok,
                        content: await response.text()
                    }
                })
                .then((data) => {
                    if (data.success) {
                        this.showSuccess(data.content)
                    } else {
                        this.showDanger(data.content)
                    }
                })
                .catch((err) => {
                    this.showDanger('Что-то пошло не так. Попробуйте позже или позвоните нам по номеру 555-777')
                })
        })
    }

    validateModal(_this) {
        let inputs = _this.closest('.modal').querySelectorAll('input');
        let isValid = true;
        inputs.forEach((el) => {
            if (el.classList.contains('needs-validation')) {
                el.classList.remove('is-invalid')
                el.classList.remove('is-valid')
                if (!el.checkValidity()) {
                    el.classList.add('is-invalid')
                    isValid = false;
                } else {
                    el.classList.remove('is-invalid')
                }
            }
        })

        return {
            valid: isValid,
            inputs: inputs
        }
    }

    getQueryString() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.toString().length > 0 ? `?${urlParams.toString()}` : '';
    }

    showSuccess(redirectUrl = null) {
        const defaultText = 'Заявка успешно принята! В ближайшее время с Вами свяжется наш менеджер.'
        this.success.forEach(box => {
            box.innerHTML = defaultText;
            box.style.display = 'block'
        })
        setTimeout(() => {
            window.top.location.href = redirectUrl ? redirectUrl : window.location.origin + '/thankyou/';
        }, 500);
    }

    showDanger(text = null) {
        const defaultText = 'При регистрации заявки возникла ошибка. Попробуйте чуть позже или позвоните нам по телефону 8 (921) 4-555-777'
        this.danger.forEach(box => {
            box.innerHTML = text || defaultText
            box.style.display = 'block'
        })
    }

    setForm(city, service) {
        const activeModal = document.querySelector('.modal.is-open');
        if (activeModal) {
            activeModal.querySelector('input[name="city"]').value = city;
            activeModal.querySelector('input[name="service"]').value = service;
        }
    }

    getCity() {
        const field = document.querySelector('span[data-js-selected-city]');
        return field ? field.innerText.trim() : 'Нет';
    }
}
